import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
const rows = [
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456896',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456897',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456898',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456899',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456885',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456886',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456887',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456888',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
];
export default function DataGridD() {
	const { bookinghistoryagent } = useSelector((state) => state.user);
	const columns = [
		{ field: 'orderId', headerName: 'ORDER ID', width: 150 },
		{
			field: 'origin',
			headerName: 'DEPART FROM',
			width: 150,
			editable: true,
		},
		{
			field: 'destination',
			headerName: 'JOURNEY TO',
			width: 150,
			editable: true,
		},
		{
			field: 'dob',
			headerName: 'DATE OF BOOKING',
			type: 'number',
			width: 150,
			editable: true,
		},
		{
			field: 'travelDate',
			headerName: 'JOURNEY DATE',
			description: 'This column has a value getter and is not sortable.',
			width: 160,
			type: 'number',
			editable: true,
		},
		{
			field: 'ticketCost',
			headerName: 'TICKET COST',
			type: 'number',
			width: 150,
			editable: true,
		},
		{
			field: 'action',
			headerName: 'ACTIONS',
			width: 300,
			renderCell: (cellValues) => {
				return (
					<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
						<EditIcon />
						<DownloadIcon style={{ marginLeft: 10 }} onClick={handleDownload} />
					</Box>
				);
			},
		},
	];
	const handleDownload = () => {};
	return (
		<Box sx={{ height: 600, width: '100%' }}>
			{bookinghistoryagent?.result?.flights.length > 0 ? (
				<DataGrid
					rows={bookinghistoryagent?.result?.flights}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 10,
							},
						},
					}}
					pageSizeOptions={[5]}
					checkboxSelection
					disableRowSelectionOnClick
				/>
			) : (
				''
			)}
		</Box>
	);
}
